import { AppConstants } from '@/app.constants';
import jwt_decode from 'jwt-decode';
import { Utils } from '@/Utils';

let jwt;
try {
    jwt = localStorage.getItem(AppConstants.LocalStorageKeys.jwt);
} catch (e) { }

export const decodeToken = (jwt: string): Token => {
    let token;
    try {
        token = jwt_decode(jwt);
    } catch (error) { }

    if (token) {
        const userName = token['sub'];
        const regionsJson = token['regions'];

        let roles =
            token[
            'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
            ];

        if (roles instanceof String) {
            roles = [roles];
        }

        return {
            regions: Utils.jsonParse<string[]>(regionsJson) || [],
            userName: userName || '',
            roles,
        };
    }
    return null;
};

export const setReferrer = (value: boolean) => {
    store.referrer = value;
}

export interface State {
    campaign?: any;
    submissionId: string;
    referrer: boolean;
    isAuthenticated: boolean;
    jwt: string;
    token: Token;
    hasAdminCampaigns: boolean;
    adminCampaigns: string[];
}

export interface Token {
    regions: string[];
    userName: string;
    roles?: string[];
}

export function isAdmin(): boolean {
    return store.token.roles && store.token.roles.includes('Admin');
}

export function isCampaignAdmin(campaign: string) : boolean {
    return store.adminCampaigns && store.adminCampaigns.includes(campaign);
}

export const store: State = {
    submissionId: '',
    referrer: true,
    isAuthenticated: jwt !== null,
    jwt: jwt,
    token: decodeToken(jwt || ''),
    hasAdminCampaigns: false,
    adminCampaigns: [],
};
